export const easing150Duration = "150ms";
export const easing150X1 = 0.25;
export const easing150Y1 = 0.1;
export const easing150X2 = 0.25;
export const easing150Y2 = 1;
export const easing250Duration = "250ms";
export const easing250X1 = 0.25;
export const easing250Y1 = 0.1;
export const easing250X2 = 0.25;
export const easing250Y2 = 1;
export const easing500Duration = "500ms";
export const easing500X1 = 0.5;
export const easing500Y1 = 0.1;
export const easing500X2 = 0.5;
export const easing500Y2 = 1;
export const springFirmTension = 200;
export const springFirmFriction = 20;
export const springFirmMass = 0.5;
export const springFirmVelocity = 2;
export const framerSnappyType = "spring";
export const framerSnappyDamping = 10;
export const framerSnappyMass = 0.01;
export const framerSnappyStiffness = 500;
export const framerSnappyVelocity = 500;
export const framerTightType = "spring";
export const framerTightDamping = 15;
export const framerTightMass = 0.4;
export const framerTightStiffness = 300;
export const framerTightVelocity = 5;
export const framerFirmType = "spring";
export const framerFirmDamping = 14;
export const framerFirmMass = 0.5;
export const framerFirmStiffness = 200;
export const framerFirmVelocity = 3;
export const framerSoftType = "spring";
export const framerSoftDamping = 14;
export const framerSoftMass = 0.35;
export const framerSoftStiffness = 125;
export const framerSoftVelocity = 30;
export const animationSpin500Duration = 2;
export const animationSpin700Duration = 0.75;